<template>
    <Slide :title="title" :subtitle="subtitle">
        <div>
            <p>Create an account password to finish setting up your account. After setup, you'll be able to view lead prices for your operating states and industry.</p>
            <div class="cr:grid cr:grid-cols-1 cr:gap-5 cr:w-full cr:md:w-[25rem] cr:my-5 cr:mx-auto cr:items-center cr:justify-center">
                <div>
                    <p>Password*</p>
                    <CustomInput
                        :placeholder="'Minimum 8 characters'"
                        :input-type="'password'"
                        :id="'password'"
                        v-model="password"
                    />
                </div>
                <div>
                    <p>Confirm Password*</p>
                    <CustomInput
                        :placeholder="'Re-enter your password'"
                        :input-type="'password'"
                        :id="'confirm_password'"
                        v-model="confirmPassword"
                    />
                </div>
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import CustomInput from "@/components/elements/CustomInput.vue";
import {computed, ref} from "vue";
import Slide from "@/components/slides/Slide.vue";
import {useErrorStore} from "@/stores/error.ts";
import Validation from "@/services/Validation.ts";

const errorStore = useErrorStore();
const password = ref('');
const confirmPassword = ref('');
const props = defineProps({
    title: {
        type: String,
        default: 'Finish setting up your account'
    },
    subtitle: {
        type: String,
        default: 'Create a user password to view lead prices'
    }
});
const canContinue = computed(() => true);
const slidePayload = computed(() => {
    return {
        create_user: true,
        password: password.value,
        password_confirmation: confirmPassword.value
    }
});

const validate = () => {
    if (!Validation.validPassword(password.value)) {
        errorStore.report('Password must be at least 8 characters long and include at least one letter, one number, and one special character.', 10000)
        return false;
    }

    if (password.value !== confirmPassword.value) {
        errorStore.report('The password confirmation does not match.')
        return false;
    }

    return true;
}

defineExpose({
    canContinue,
    slidePayload,
    validate
});

</script>